import {
  LayoutDashboard,
  Settings2,
  Plus,
  Package,
  List,
  Upload,
  Truck,
  Warehouse,
  Banknote,
  Undo2,
  Users,
  CreditCard,
  Clock,
  MessageCircle,
  Search,
} from "lucide-react";

export const navigationConfig = {
  client: {
    main: [
      {
        title: "navigation.dashboard",
        url: "/",
        icon: LayoutDashboard,
        isActive: true,
        description: "Overview and analytics",
      },
    ],
    operations: [
      {
        title: "navigation.packages",
        url: "/packages",
        icon: Package,
        items: [
          {
            title: "navigation.packages",
            url: "/packages",
            icon: List,
          },
          {
            title: "navigation.addPackage",
            url: "/packages/create",
            icon: Plus,
          },
          {
            title: "packages.importPackages",
            url: "/packages/import",
            icon: Upload,
          },
        ],
      },
      {
        title: "navigation.trackPackage",
        url: "/tracking",
        icon: Search,
      },
      {
        title: "navigation.pickups",
        url: "/pickups",
        icon: Truck,
        items: [
          {
            title: "navigation.pickups",
            url: "/pickups",
            icon: List,
          },
          {
            title: "navigation.addPickup",
            url: "/pickups/create",
            icon: Plus,
          },
        ],
      },
    ],
    inventory: [
      {
        title: "navigation.inventoryManagment",
        url: "/products",
        icon: Warehouse,
        items: [
          {
            title: "navigation.inventory",
            url: "/products",
            icon: List,
          },
          {
            title: "navigation.addProduct",
            url: "/products/create",
            icon: Plus,
          },
          {
            title: "products.importProducts",
            url: "/products/import",
            icon: Upload,
          },
        ],
      },
    ],
    financial: [
      {
        title: "navigation.invoices",
        url: "/invoices",
        icon: Banknote,
      },
    ],
    support: [
      {
        title: "tickets.tickets",
        url: "/tickets",
        icon: MessageCircle,
      },
    ],
  },
  admin: {
    main: [
      {
        title: "navigation.dashboard",
        url: "/",
        icon: LayoutDashboard,
        description: "System overview",
      },
    ],
    operations: [
      {
        title: "navigation.packages",
        url: "/packages",
        icon: Package,
      },
      {
        title: "navigation.trackPackage",
        url: "/tracking",
        icon: Search,
      },
      {
        title: "navigation.pickups",
        url: "/pickups",
        icon: Truck,
      },
    ],
    livreurManagement: [
      {
        title: "navigation.packagesManagement",
        url: "/packages/livreur-management",
        icon: Truck,
      },
      {
        title: "navigation.pickupManagement",
        url: "/pickups/livreur-management",
        icon: Users,
      },
    ],
    inventory: [
      {
        title: "navigation.inventoryManagment",
        url: "/products",
        icon: Warehouse,
      },
    ],
    financial: [
      {
        title: "navigation.invoices",
        url: "/invoices",
        icon: Banknote,
        items: [
          {
            title: "navigation.invoices",
            url: "/invoices",
            icon: List,
          },
          {
            title: "navigation.addInvoice",
            url: "/invoices/create",
            icon: Plus,
          },
        ],
      },
      {
        title: "navigation.returnVoucher",
        url: "/return-voucher",
        icon: Undo2,
        items: [
          {
            title: "navigation.returnVoucher",
            url: "/return-voucher",
            icon: List,
          },
          {
            title: "navigation.addReturnVoucher",
            url: "/return-voucher/create",
            icon: Plus,
          },
        ],
      },
    ],
    management: [
      {
        title: "navigation.users",
        url: "/users",
        icon: Users,
      },
      // {
      //   title: "Admin Tools",
      //   icon: Shield,
      //   items: [
      //     {
      //       title: "Analytics & Reports",
      //       url: "/admin/analytics",
      //       icon: BarChart3,
      //     },
      //     {
      //       title: "System Logs",
      //       url: "/admin/logs",
      //       icon: FileText,
      //     },
      //     {
      //       title: "System Settings",
      //       url: "/admin/settings",
      //       icon: Settings2,
      //     },
      //   ],
      // },
      {
        title: "navigation.banking",
        icon: CreditCard,
        url: "/banking/pending-requests",
      },
      {
        title: "navigation.settings",
        icon: Settings2,
        items: [
          {
            title: "settings.general",
            url: "/settings",
            icon: Settings2,
          },
          {
            title: "settings.cities",
            url: "/settings/cities",
            icon: List,
          },
        ],
      },
    ],
    support: [
      {
        title: "tickets.tickets",
        url: "/tickets",
        icon: MessageCircle,
      },
    ],
  },
  manager: {
    main: [
      {
        title: "navigation.dashboard",
        url: "/",
        icon: LayoutDashboard,
        description: "Management overview",
      },
    ],
    operations: [
      {
        title: "navigation.livreurManagement",
        url: "/packages/livreur-management",
        icon: Truck,
      },
      {
        title: "navigation.pickupLivreurManagement",
        url: "/pickups/livreur-management",
        icon: Users,
      },
    ],
    financial: [
      {
        title: "navigation.invoices",
        url: "/invoices",
        icon: Banknote,
        items: [
          {
            title: "navigation.invoices",
            url: "/invoices",
            icon: List,
          },
          {
            title: "navigation.addInvoice",
            url: "/invoices/create",
            icon: Plus,
          },
        ],
      },
      {
        title: "navigation.returnVoucher",
        url: "/return-voucher",
        icon: Undo2,
        items: [
          {
            title: "navigation.returnVoucher",
            url: "/return-voucher",
            icon: List,
          },
          {
            title: "navigation.addReturnVoucher",
            url: "/return-voucher/create",
            icon: Plus,
          },
        ],
      },
    ],
    management: [
      {
        title: "navigation.users",
        url: "/users",
        icon: Users,
      },
      {
        title: "navigation.bankingManagement",
        icon: CreditCard,
        items: [
          {
            title: "navigation.pendingApprovals",
            url: "/banking/pending-requests",
            icon: Clock,
          },
        ],
      },
    ],
    support: [
      {
        title: "tickets.tickets",
        url: "/tickets",
        icon: MessageCircle,
      },
    ],
  },
  livreur: {
    main: [
      {
        title: "navigation.dashboard",
        url: "/",
        icon: LayoutDashboard,
        isActive: true,
        description: "Delivery overview",
      },
    ],
    delivery: [
      {
        title: "navigation.packages",
        url: "/packages",
        icon: Package,
      },
      {
        title: "navigation.trackPackage",
        url: "/tracking",
        icon: Search,
      },
      {
        title: "navigation.pickups",
        url: "/pickups",
        icon: Package,
      },
    ],
    financial: [
      {
        title: "navigation.invoices",
        url: "/invoices",
        icon: Banknote,
      },
    ],
  },
  collector: {
    main: [
      {
        title: "navigation.dashboard",
        url: "/",
        icon: LayoutDashboard,
        isActive: true,
        description: "Delivery overview",
      },
    ],
    delivery: [
      {
        title: "navigation.pickups",
        url: "/pickups",
        icon: Package,
      },
    ],
  },
  clientSupport: {
    main: [
      {
        title: "navigation.dashboard",
        url: "/",
        icon: LayoutDashboard,
        isActive: true,
        description: "Client support overview",
      },
    ],
    operations: [
      {
        title: "navigation.packages",
        url: "/packages",
        icon: Package,
      },
      {
        title: "navigation.trackPackage",
        url: "/tracking",
        icon: Search,
      },
      {
        title: "navigation.livreurManagement",
        url: "/packages/livreur-management",
        icon: Truck,
      },
      {
        title: "navigation.pickupLivreurManagement",
        url: "/pickups/livreur-management",
        icon: Users,
      },
    ],
    inventory: [
      {
        title: "navigation.inventoryManagment",
        url: "/products",
        icon: Warehouse,
      },
    ],
    financial: [
      {
        title: "navigation.invoices",
        url: "/invoices",
        icon: Banknote,
        items: [
          {
            title: "navigation.invoices",
            url: "/invoices",
            icon: List,
          },
          {
            title: "navigation.addInvoice",
            url: "/invoices/create",
            icon: Plus,
          },
        ],
      },
      {
        title: "navigation.returnVoucher",
        url: "/return-voucher",
        icon: Undo2,
        items: [
          {
            title: "navigation.returnVoucher",
            url: "/return-voucher",
            icon: List,
          },
          {
            title: "navigation.addReturnVoucher",
            url: "/return-voucher/create",
            icon: Plus,
          },
        ],
      },
    ],
    support: [
      {
        title: "tickets.tickets",
        url: "/tickets",
        icon: MessageCircle,
      },
    ],
  },
  accountant: {
    main: [
      {
        title: "navigation.dashboard",
        url: "/",
        icon: LayoutDashboard,
        isActive: true,
        description: "Financial overview",
      },
    ],
    financial: [
      {
        title: "navigation.invoices",
        url: "/invoices",
        icon: Banknote,
        items: [
          {
            title: "navigation.invoices",
            url: "/invoices",
            icon: List,
          },
          {
            title: "navigation.addInvoice",
            url: "/invoices/create",
            icon: Plus,
          },
        ],
      },
      {
        title: "navigation.returnVoucher",
        url: "/return-voucher",
        icon: Undo2,
        items: [
          {
            title: "navigation.returnVoucher",
            url: "/return-voucher",
            icon: List,
          },
          {
            title: "navigation.addReturnVoucher",
            url: "/return-voucher/create",
            icon: Plus,
          },
        ],
      },
    ],
    support: [
      {
        title: "tickets.tickets",
        url: "/tickets?category=payment_issue",
        icon: MessageCircle,
        description: "Payment issue tickets only",
      },
    ],
  },
};
